/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'

type Props = {
  educator: any
}

const status = ['Pending', 'Rejected', 'Approved', 'Ceased']
const EducatorNameCell: FC<Props> = ({educator}) => {
  const navigate = useNavigate()
  return (
    <div className='d-flex align-items-center'>
      {/* begin:: Avatar */}
      <div className='d-flex flex-column'>
        {status.includes(educator?.status) ? (
          <a
            className='menu-link cursor-pointer'
            onClick={(e) => {
              e.preventDefault()
              navigate(`${educator._id}/view`)
            }}
          >
            {educator?.basicInformation?.fullName}
          </a>
        ) : (
          educator?.basicInformation?.fullName
        )}
      </div>
    </div>
  )
}

export {EducatorNameCell}
